import React from "react";
import { CgSpinnerTwo } from "react-icons/cg";

/**
 * Renders a button loader component with optional text and spinner.
 *
 * @param {Object} param0 - An object containing the following properties:
 *   - text (string): The optional text to display alongside the spinner
 *   - loadingFirst (boolean): Flag to determine if the spinner should be displayed before the text
 *   - textOnly (boolean): Flag to determine if only the text should be displayed without the spinner
 * @return {JSX.Element} The rendered button loader component
 */
const ButtonLoader = ({ text, loadingFirst, textOnly, spinnerColor }) => {
  return (
    <div
      className={`pointer-events-none absolute left-0 top-0 flex h-[100%] w-full !items-center !justify-center ${
        loadingFirst ? "flex-row-reverse" : ""
      }`}
    >
      {text && (
        <span className={`${loadingFirst ? "ml-[8px]" : "mr-[8px]"}`}>
          {text}
        </span>
      )}
      {!textOnly && (
        <CgSpinnerTwo
          className="buttonLoader animate-spin"
          style={{ color: spinnerColor }}
        />
      )}
    </div>
  );
};

export default ButtonLoader;
